<template>
    <div :class="`social-sharing-container ${linkData.loading || linkData.error ? 'disabled' : ''}`">
        <div class="sharing-buttons-container">
            <div
                :class="`${item.name}-button button`"
                :key="item.name"
                v-for="item in mainList"
                @click.prevent="share(item.name)"
                :data-social-sharing-platform="item.label"
            ></div>
        </div>
        <div class="copy-to-clipboard-container">
            <div class="copy-container">
                <div class="copy-text">
                    <div class="text-label">LINK TO VIDEO</div>
                    <input class="text" :value="linkData.link" spellcheck="false" @keypress.prevent>
                </div>
                <div
                    class="copy-button"
                    v-clipboard:copy="linkData.link"
                    v-clipboard:success="showCopiedPopup"
                >
                    <img src="../../../assets/img/copy.svg" alt="copy"/>
                </div>
                <transition name="popup">
                    <div class="copied-popup" v-if="copiedPopup">Copied to clipboard</div>
                </transition>
            </div>
            <div class="more-sharing-container" ref="moreSharing">
                <div class="more-button button" @click.prevent="togglePopup">
                    <img src="../../../assets/img/more_button.svg" alt="more"/>
                </div>
                <transition name="list">
                    <div class="sharing-popup" v-show="sharingPopup">
                        <div class="search-wrapper">
                            <input type="text" @input.prevent="onInput" :value="search" placeholder="Find a service"/>
                            <img src="../../../assets/img/search.svg" alt="search"/>
                        </div>
                        <div class="list-container">
                            <div class="list" v-if="filteredList.length">
                                <div
                                    class="list-item social-sharing-button"
                                    :key="item.name"
                                    v-for="item in filteredList"
                                    @click.prevent="share(item.name)"
                                    :data-social-sharing-platform="item.label"
                                >
                                    <div class="social-media-icon"
                                         :style="{ backgroundPositionX: item.positionX + 'px', backgroundPositionY: item.positionY + 'px' }"></div>
                                    <div>{{item.label}}</div>
                                </div>
                            </div>
                            <div class="not-found" v-else>Not found</div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import constants from '../../helpers/constants';
import SocialSharing from '../../helpers/socialSharing';

const { mapGetters } = createNamespacedHelpers('main');
const { FACEBOOK, TWITTER, WHATS_APP, EMAIL, ...popupList } = constants.socialSharing;

export default {
    name: 'SocialSharing',
    data() {
        return {
            mainList: [FACEBOOK, TWITTER, WHATS_APP, EMAIL],
            popupList,
            copiedPopup: false,
            sharingPopup: false,
            search: '',
            title: '',
            text: ''
        };
    },
    mounted() {
        document.addEventListener('click', this.handleWindowClick);
    },
    destroyed() {
        document.removeEventListener('click', this.handleWindowClick);
    },
    methods: {
        share(name) {
            const url = SocialSharing[name]({ url: this.linkData.link, title: this.title, text: this.text });

            window.open(url);
            this.sharingPopup = false;
        },
        togglePopup() {
            this.sharingPopup = !this.sharingPopup;
        },
        showCopiedPopup() {
            this.copiedPopup = true;
            setTimeout(() => {
                this.copiedPopup = false;
            }, 2000)
        },
        onInput(e) {
            this.search = e.target.value;
        },
        handleWindowClick(e) {
            const wasClickedOutsidePopup = !this.$refs.moreSharing.contains(e.target);

            if(wasClickedOutsidePopup){
                this.sharingPopup = false;
            }
        }
    },
    updated() {
        if(!this.sharingPopup){
            this.search = '';
        }
    },
    computed: {
        ...mapGetters({
            activePlaybackSharedLinkData: 'activePlaybackSharedLinkData'
        }),
        linkData() {

            /** the initial object for cases when active playback data does not yet exist **/
            const initObject = {
                link: '',
                loading: true,
                error: false,
                errorMessage: ''
            };

            return this.activePlaybackSharedLinkData || initObject
        },
        filteredList() {
            return Object.values(this.popupList).filter(item => item.label.toLowerCase().includes(this.search.toLowerCase()));
        }
    }
}
</script>
